import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import MobileAppsDetail from "./pages/MobileAppsDetail";
import WebDevDetail from "./pages/WebDevDetail";
import BackendDetail from "./pages/BackendDetail";
import CloudDetail from "./pages/CloudDetail";
import UIUXDetail from "./pages/UIUXDetail";
import AIAutomationDetail from "./pages/AIAutomationDetail";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import CRMPage from "./pages/CRMPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import SEOServicesPage from "./pages/SEOServicesPage";
import AIServicesPage from "./pages/AIServicesPage";
import NEMTDetail from "./pages/NEMTDetail";
import SecurityGuardDetail from "./pages/SecurityGuardDetail";
import NotFoundPage from "./pages/NotFoundPage";
import logo from "./logo.png";
import useSEO from "./utils/useSEO";
import { IlloStyles } from "./components/AnimatedIllustrations";

// ─── SVG ICONS ───────────────────────────────────────────────────────────────
const Icons = {
  Web: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Mobile: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <rect x="5" y="2" width="14" height="20" rx="2" />
      <path d="M12 18h.01" />
    </svg>
  ),
  Backend: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <rect x="2" y="3" width="20" height="4" rx="1" />
      <rect x="2" y="10" width="20" height="4" rx="1" />
      <rect x="2" y="17" width="20" height="4" rx="1" />
      <path d="M6 5h.01M6 12h.01M6 19h.01" />
    </svg>
  ),
  Cloud: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  ),
  Design: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
      <circle cx="8.5" cy="7.5" r="1" fill="currentColor" />
      <circle cx="13.5" cy="6.5" r="1" fill="currentColor" />
      <circle cx="17.5" cy="10.5" r="1" fill="currentColor" />
      <circle cx="6.5" cy="12.5" r="1" fill="currentColor" />
    </svg>
  ),
  AI: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <rect x="4" y="8" width="16" height="10" rx="2" />
      <path d="M8 8V6a4 4 0 0 1 8 0v2" />
      <circle cx="9" cy="13" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15" cy="13" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  ),
  Claim: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <path d="M12 2l7 4v5c0 4.418-3.134 8.566-7 9.95C8.134 19.566 5 15.418 5 11V6l7-4z" />
      <path d="M9 11.5l2 2 4-4.5" />
    </svg>
  ),
  Code: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-7 h-7"
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="M9 9.5L6.5 12 9 14.5M15 9.5l2.5 2.5-2.5 2.5M12.8 8.5l-1.6 7" />
    </svg>
  ),
  ArrowRight: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className="w-4 h-4"
    >
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  ),
  Menu: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className="w-6 h-6"
    >
      <path d="M3 12h18M3 6h18M3 18h18" />
    </svg>
  ),
  Close: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      className="w-6 h-6"
    >
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  ),
  Twitter: () => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  Github: () => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0 0 22 12.017C22 6.484 17.522 2 12 2z" />
    </svg>
  ),
  LinkedIn: () => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  ),
  Mail: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-5 h-5"
    >
      <path d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
    </svg>
  ),
  Phone: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-5 h-5"
    >
      <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25z" />
    </svg>
  ),
  Location: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-5 h-5"
    >
      <path d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
      <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0z" />
    </svg>
  ),
  Star: () => (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="w-4 h-4 text-amber-400"
    >
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  ),
  Check: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      className="w-4 h-4"
    >
      <path d="M5 13l4 4L19 7" />
    </svg>
  ),
  Shield: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-5 h-5"
    >
      <path d="M12 2l7 4v5c0 4.418-3.134 8.566-7 9.95C8.134 19.566 5 15.418 5 11V6l7-4z" />
    </svg>
  ),
  Trophy: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-5 h-5"
    >
      <path d="M8 21h8m-4-4v4M7 4H4a1 1 0 0 0-1 1v3a4 4 0 0 0 4 4h.5M17 4h3a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4h-.5M6 4h12v5a6 6 0 0 1-12 0V4z" />
    </svg>
  ),
  Verified: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      className="w-5 h-5"
    >
      <path d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-.529 3.78 3.745 3.745 0 0 1-3.780.53A3.745 3.745 0 0 1 12 21a3.745 3.745 0 0 1-3.098-1.622 3.745 3.745 0 0 1-3.78-.53 3.745 3.745 0 0 1-.53-3.78A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 .53-3.78 3.745 3.745 0 0 1 3.78-.53A3.745 3.745 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.745 3.745 0 0 1 3.78.53 3.745 3.745 0 0 1 .53 3.78A3.745 3.745 0 0 1 21 12z" />
    </svg>
  ),
};

// ─── TECH SVG ICONS ──────────────────────────────────────────────────────────
const TechIcons = {
  React: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9" fill="none">
      <circle cx="12" cy="12" r="2.2" fill="#61DAFB" />
      <ellipse
        cx="12"
        cy="12"
        rx="10"
        ry="3.6"
        stroke="#61DAFB"
        strokeWidth="1.1"
      />
      <ellipse
        cx="12"
        cy="12"
        rx="10"
        ry="3.6"
        stroke="#61DAFB"
        strokeWidth="1.1"
        transform="rotate(60 12 12)"
      />
      <ellipse
        cx="12"
        cy="12"
        rx="10"
        ry="3.6"
        stroke="#61DAFB"
        strokeWidth="1.1"
        transform="rotate(120 12 12)"
      />
    </svg>
  ),
  "Node.js": () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9" fill="#339933">
      <path d="M12 2L3 7v10l9 5 9-5V7L12 2zm0 2.4L19.5 8.7v6.6L12 19.6l-7.5-4.3V8.7L12 4.4z" />
    </svg>
  ),
  TypeScript: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9">
      <rect width="24" height="24" rx="3" fill="#3178C6" />
      <path
        d="M4 13.5h3V19H8.5V13.5h3V12H4v1.5zm9.5 0V19H15v-2.2H18v-1.5h-3v-1.8h4.5V12H13.5v1.5z"
        fill="white"
      />
    </svg>
  ),
  MongoDB: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9">
      <path
        fill="#47A248"
        d="M12 2C9 5.8 7.5 8.8 7.5 12c0 3.8 2.1 6.8 4.5 8.8V22h1v-1.2C15.4 18.8 16.5 15.8 16.5 12 16.5 8.8 15 5.8 12 2z"
      />
    </svg>
  ),
  PostgreSQL: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9" fill="none">
      <circle cx="12" cy="12" r="10" fill="#336791" />
      <path
        d="M8 8h2.5v8H9V12H8V8zm5 0h3a2 2 0 0 1 0 4h-1.5V16H13V8zm1.5 1.5V10.5H16a.5.5 0 0 0 0-1h-.5z"
        fill="white"
      />
    </svg>
  ),
  Redis: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9" fill="none">
      <ellipse cx="12" cy="7" rx="9" ry="3.5" fill="#DC382D" />
      <path d="M3 7v4.5c0 1.93 4.03 3.5 9 3.5s9-1.57 9-3.5V7" fill="#C41B1B" />
      <path
        d="M3 11.5v4.5c0 1.93 4.03 3.5 9 3.5s9-1.57 9-3.5v-4.5"
        fill="#A51515"
      />
      <ellipse cx="12" cy="7" rx="9" ry="3.5" fill="#DC382D" />
      <ellipse cx="12" cy="7" rx="6.5" ry="2" fill="#FF6B6B" opacity=".5" />
    </svg>
  ),
  Docker: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9">
      <path
        fill="#2496ED"
        d="M4.5 10h2v2h-2v-2zm2.5 0h2v2H7v-2zm2.5 0h2v2h-2v-2zm2.5 0h2v2H12v-2zm3-3h2v2h-2V7zm-2.5 0h2v2h-2V7zm-2.5 0h2v2H10V7zM7.5 7h2v2h-2V7zm-3 0h2v2h-2V7zm-3-3h2v2h-2V4zm3 0h2v2h-2V4zm2.5 0h2v2H7V4zM21 11.5c.5-3-2-5.5-5-5.5H5.5C3 10 3 14 3 14h15.5a3 3 0 0 0 2.5-2.5z"
      />
    </svg>
  ),
  Kubernetes: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9" fill="none">
      <path
        fill="#326CE5"
        d="M12 2.5L4.5 7v10L12 21.5 19.5 17V7L12 2.5zm0 2.2l5.5 3.2v6.6L12 17.6l-5.5-3.1V7.9L12 4.7z"
      />
      <circle cx="12" cy="12" r="2.5" fill="#326CE5" />
    </svg>
  ),
  AWS: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9">
      <path
        fill="#FF9900"
        d="M6.75 11.5C4.7 11 3 12.3 3 14s1.7 3 3.75 3c.75 0 1.45-.2 2-.55L10.2 17.8C9.2 18.55 7.9 19 6.5 19 3.4 19 1 16.8 1 14s2.4-5 5.5-5c1 0 2 .3 2.8.8L8 11c-.4-.3-.8-.5-1.25-.5z"
      />
      <path
        fill="#FF9900"
        d="M15.5 8h1.5a3 3 0 0 1 0 6H15.5V8zm0 1.5v3H17a1.5 1.5 0 0 0 0-3h-1.5z"
      />
      <path fill="#FF9900" d="M8 18.5l1-1.5 7 1-1 2.5H8l1-2z" />
    </svg>
  ),
  "Next.js": () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9">
      <circle cx="12" cy="12" r="10" fill="#000" />
      <path fill="white" d="M9 8v8l8-8-8 8M14 8h2l-2.5 3L14 8z" />
    </svg>
  ),
  GraphQL: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9" fill="#E10098">
      <circle cx="12" cy="3" r="2" />
      <circle cx="20.5" cy="8" r="2" />
      <circle cx="20.5" cy="16" r="2" />
      <circle cx="12" cy="21" r="2" />
      <circle cx="3.5" cy="16" r="2" />
      <circle cx="3.5" cy="8" r="2" />
      <circle cx="12" cy="12" r="2.5" />
      <path
        d="M12 5L20.5 10M20.5 10v8M20.5 18L12 23M12 23L3.5 18M3.5 18V10M3.5 10L12 5M12 5v7M12 12L20.5 10M12 12L3.5 10M12 12v9"
        stroke="#E10098"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  Terraform: () => (
    <svg viewBox="0 0 24 24" className="w-9 h-9" fill="#7B42BC">
      <path d="M3 3l5 3v6L3 9V3zm8 0l5 3v6l-5-3V3zm-4 8.5l5 3v6l-5-3v-6zm8 2.5l5-2.5v6L15 20v-6z" />
    </svg>
  ),
};

// ─── ANIMATION UTILITIES ──────────────────────────────────────────────────────
// Lightweight, dependency-free scroll animations. Only opacity/transform are
// animated (GPU-composited), observers disconnect after firing once, and
// everything collapses to "instantly visible" under prefers-reduced-motion.
const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    if (prefersReducedMotion()) {
      setInView(true);
      return;
    }
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { threshold, rootMargin: "0px 0px -48px 0px" },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

// Scroll-reveal wrapper. variant: up | down | left | right | scale | fade | blur
function Reveal({ children, variant = "up", delay = 0, className = "" }) {
  const [ref, inView] = useInView();
  const hiddenTransform = {
    up: "translate3d(0,28px,0)",
    down: "translate3d(0,-28px,0)",
    left: "translate3d(40px,0,0)",
    right: "translate3d(-40px,0,0)",
    scale: "scale(0.93)",
    fade: "none",
    blur: "none",
  }[variant];
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "none" : hiddenTransform,
        filter:
          variant === "blur" ? (inView ? "blur(0px)" : "blur(10px)") : undefined,
        transition: `opacity 0.7s cubic-bezier(0.22,1,0.36,1) ${delay}ms, transform 0.7s cubic-bezier(0.22,1,0.36,1) ${delay}ms, filter 0.7s ease ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

// Animated counter — parses "120+", "98%", "6yrs" and counts the numeric part
// up with an ease-out curve once scrolled into view.
function CountUp({ value, duration = 1500, className = "" }) {
  const match = String(value).match(/^([^0-9]*)([\d.]+)(.*)$/);
  const [ref, inView] = useInView(0.4);
  const [display, setDisplay] = useState(match ? "0" : value);
  const target = match ? parseFloat(match[2]) : 0;
  const decimals = match ? (match[2].split(".")[1] || "").length : 0;
  useEffect(() => {
    if (!inView || !match) return;
    if (prefersReducedMotion()) {
      setDisplay(match[2]);
      return;
    }
    let startTime;
    let raf;
    const tick = (t) => {
      if (startTime === undefined) startTime = t;
      const p = Math.min((t - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay((target * eased).toFixed(decimals));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);
  if (!match) return <span className={className}>{value}</span>;
  return (
    <span ref={ref} className={className}>
      {match[1]}
      {display}
      {match[3]}
    </span>
  );
}

// Gentle scroll parallax for decorative elements (single rAF-throttled listener)
function useParallax(speed = 0.12) {
  const ref = useRef(null);
  useEffect(() => {
    if (prefersReducedMotion()) return;
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        if (ref.current) {
          ref.current.style.transform = `translate3d(0, ${window.scrollY * speed}px, 0)`;
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [speed]);
  return ref;
}

// Shared keyframes + micro-interaction classes for the homepage
function AnimStyles() {
  return (
    <style>{`
      @keyframes heroIn {
        from { opacity: 0; transform: translate3d(0, 26px, 0); }
        to { opacity: 1; transform: translate3d(0, 0, 0); }
      }
      .hero-in { animation: heroIn 0.9s cubic-bezier(0.22, 1, 0.36, 1) both; }

      @keyframes orbFloat {
        0%, 100% { transform: translate3d(0, 0, 0) scale(1); }
        50% { transform: translate3d(0, -34px, 0) scale(1.04); }
      }
      .orb-float { animation: orbFloat 14s ease-in-out infinite; }
      .orb-float-slow { animation: orbFloat 20s ease-in-out infinite reverse; }

      @keyframes gradShift {
        0%, 100% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
      }
      .grad-animate { background-size: 200% 200%; animation: gradShift 7s ease infinite; }

      /* Nav link underline sweep */
      .nav-underline { position: relative; }
      .nav-underline::after {
        content: ""; position: absolute; left: 16px; right: 16px; bottom: 5px;
        height: 1.5px; border-radius: 2px;
        background: linear-gradient(90deg, #8b5cf6, #22d3ee);
        transform: scaleX(0); transform-origin: left;
        transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
      }
      .nav-underline:hover::after { transform: scaleX(1); }

      /* Icon micro-animation on card hover */
      .icon-pop { transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1); }
      .group:hover .icon-pop { transform: scale(1.12) rotate(-4deg); }

      @media (prefers-reduced-motion: reduce) {
        .hero-in, .orb-float, .orb-float-slow, .grad-animate, .animate-marquee { animation: none !important; }
        .nav-underline::after { transition: none; }
        .icon-pop { transition: none; }
      }
    `}</style>
  );
}

// ─── DATA ─────────────────────────────────────────────────────────────────────
const SERVICES = [
  {
    icon: "Web",
    title: "Web Development",
    desc: "Blazing-fast, pixel-perfect web apps built with React and Next.js. From SPAs to complex enterprise portals — built to rank and convert.",
    color: "from-violet-500/20 to-violet-600/5",
    accent: "text-violet-400",
    border: "border-violet-500/20",
  },
  {
    icon: "Mobile",
    title: "Mobile Development",
    desc: "Native iOS, Android, and React Native apps built for performance. We handle App Store submission through to post-launch monitoring.",
    color: "from-cyan-500/20 to-cyan-600/5",
    accent: "text-cyan-400",
    border: "border-cyan-500/20",
  },
  {
    icon: "Backend",
    title: "Backend Engineering",
    desc: "Scalable Node.js APIs, microservices, and database architectures built for millions of users and zero downtime.",
    color: "from-emerald-500/20 to-emerald-600/5",
    accent: "text-emerald-400",
    border: "border-emerald-500/20",
  },
  {
    icon: "Cloud",
    title: "Cloud Solutions",
    desc: "AWS, GCP, and Azure deployments with infrastructure-as-code and zero-downtime CI/CD pipelines. Cut cloud spend by up to 40%.",
    color: "from-sky-500/20 to-sky-600/5",
    accent: "text-sky-400",
    border: "border-sky-500/20",
  },
  {
    icon: "Design",
    title: "UI/UX Design",
    desc: "Human-centered design systems that convert. We prototype, test, and iterate until every touchpoint is flawless.",
    color: "from-rose-500/20 to-rose-600/5",
    accent: "text-rose-400",
    border: "border-rose-500/20",
  },
  {
    icon: "AI",
    title: "AI & Automation",
    desc: "LLM integrations, intelligent agents, and workflow automation that eliminate manual work and make your product feel like magic.",
    color: "from-amber-500/20 to-amber-600/5",
    accent: "text-amber-400",
    border: "border-amber-500/20",
  },
  {
    icon: "Code",
    title: "Custom Software Development",
    desc: "End-to-end custom platforms tailored to your exact workflow — internal tools, client portals, and industry-specific systems built to last.",
    color: "from-indigo-500/20 to-indigo-600/5",
    accent: "text-indigo-400",
    border: "border-indigo-500/20",
  },
  {
    icon: "Claim",
    title: "ClaimGuard NEMT",
    desc: "Our specialized NEMT claims management solution — denial prevention, Medicaid billing, and compliance that lift reimbursement rates for medical transport providers.",
    color: "from-teal-500/20 to-teal-600/5",
    accent: "text-teal-400",
    border: "border-teal-500/20",
  },
];

const TECH_STACK = [
  { name: "React", IconComp: TechIcons.React },
  { name: "Node.js", IconComp: TechIcons["Node.js"] },
  { name: "TypeScript", IconComp: TechIcons.TypeScript },
  { name: "MongoDB", IconComp: TechIcons.MongoDB },
  { name: "PostgreSQL", IconComp: TechIcons.PostgreSQL },
  { name: "Redis", IconComp: TechIcons.Redis },
  { name: "Docker", IconComp: TechIcons.Docker },
  { name: "Kubernetes", IconComp: TechIcons.Kubernetes },
  { name: "AWS", IconComp: TechIcons.AWS },
  { name: "Next.js", IconComp: TechIcons["Next.js"] },
  { name: "GraphQL", IconComp: TechIcons.GraphQL },
  { name: "Terraform", IconComp: TechIcons.Terraform },
];

const PROJECTS = [
  {
    title: "NexusPay",
    category: "Fintech Platform",
    desc: "Real-time payment infrastructure processing $2M+ daily transactions with sub-100ms latency and bank-grade security.",
    image: require("./assets/nexus.png"),
    tags: ["React", "Node.js", "PostgreSQL", "AWS"],
    gradient: "from-violet-600 to-indigo-700",
    stats: [
      { label: "Daily TXs", value: "2M+" },
      { label: "Uptime", value: "99.99%" },
      { label: "Latency", value: "<100ms" },
    ],
  },
  {
    title: "HelixAI",
    category: "AI SaaS",
    desc: "Intelligent document processing platform that extracts, classifies, and routes 50k+ documents daily using LLM pipelines.",
    image: require("./assets/helix.png"),
    tags: ["Next.js", "Python", "OpenAI", "GCP"],
    gradient: "from-cyan-600 to-teal-700",
    stats: [
      { label: "Docs/Day", value: "50K+" },
      { label: "Accuracy", value: "98.7%" },
      { label: "Users", value: "12K" },
    ],
  },
];

const TESTIMONIALS = [
  {
    videoId: "7CnjS0KjhhM",
    name: "Bill H.",
    role: "CTO, NexusPay",
    avatar: "BH",
    avatarColor: "from-violet-500 to-indigo-600",
    feedback:
      "BerryByte didn't just build our platform — they architected a system that scaled from 0 to $2M in daily transactions without breaking a sweat. Absolutely world-class engineering team.",
    rating: 5,
    company: "NexusPay",
  },
];

// ─── REVIEW PLATFORMS ─────────────────────────────────────────────────────────
const REVIEW_PLATFORMS = [
  {
    name: "Clutch",
    rating: "4.9",
    reviews: "32 Reviews",
    color: "#E31B23",
    bgColor: "rgba(227,27,35,0.08)",
    borderColor: "rgba(227,27,35,0.2)",
    logo: () => (
      <svg viewBox="0 0 60 20" className="h-5">
        <rect width="60" height="20" rx="3" fill="#E31B23" />
        <path
          d="M5 14V6h2v3.5h3V6h2v8h-2v-3H7v3H5zm9-8h2v8h-2V6zm3.5 4c0-2.5 1.8-4.2 4-4.2 1.4 0 2.4.6 3 1.5l-1.5 1c-.3-.5-.8-.8-1.5-.8-1.2 0-2 .9-2 2.5s.8 2.5 2 2.5c.7 0 1.2-.3 1.5-.8l1.5 1c-.6.9-1.6 1.5-3 1.5-2.2 0-4-1.7-4-4.2zm8.5 4V6h4.5c1.5 0 2.5.8 2.5 2 0 .8-.5 1.5-1.2 1.8.9.3 1.5 1 1.5 2 0 1.4-1.1 2.2-2.7 2.2H26zm2-5h2.2c.5 0 .8-.3.8-.7s-.3-.6-.8-.6H28v1.3zm0 3.3h2.4c.6 0 .9-.3.9-.8s-.3-.8-.9-.8H28v1.6zm7-3.3V6h2v8h-2V9zm5 5V7.8H38V6h5.5v1.8H42V14h-2z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    name: "Trustpilot",
    rating: "4.8",
    reviews: "28 Reviews",
    color: "#00B67A",
    bgColor: "rgba(0,182,122,0.08)",
    borderColor: "rgba(0,182,122,0.2)",
    logo: () => (
      <svg viewBox="0 0 90 20" className="h-5">
        <path
          d="M2 10l3 2.5-1 3.5 3-2.5 3 2.5-1-3.5 3-2.5h-4L8 6.5 6 10H2z"
          fill="#00B67A"
        />
        <text
          x="22"
          y="15"
          fontFamily="Arial"
          fontWeight="bold"
          fontSize="12"
          fill="white"
        >
          Trustpilot
        </text>
      </svg>
    ),
  },
  {
    name: "DesignRush",
    rating: "4.9",
    reviews: "15 Reviews",
    color: "#0052CC",
    bgColor: "rgba(0,82,204,0.08)",
    borderColor: "rgba(0,82,204,0.2)",
    logo: () => (
      <svg viewBox="0 0 24 24" className="h-5 w-5">
        <path
          fill="#0052CC"
          d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.5l7.5 3.75v7.5L12 19.5l-7.5-3.75v-7.5L12 4.5z"
        />
        <path fill="#0052CC" d="M9 9l6 3-6 3V9z" />
      </svg>
    ),
  },
  {
    name: "GoodFirms",
    rating: "4.8",
    reviews: "22 Reviews",
    color: "#0055A5",
    bgColor: "rgba(0,85,165,0.08)",
    borderColor: "rgba(0,85,165,0.2)",
    logo: () => (
      <svg viewBox="0 0 24 24" className="h-5 w-5">
        <circle cx="12" cy="12" r="10" fill="#0055A5" />
        <path
          d="M12 7a5 5 0 0 1 4.33 7.5H14.5A3 3 0 1 0 9 12H7A5 5 0 0 1 12 7zm0 4a1 1 0 1 1 0 2H9.17A3 3 0 0 0 12 15a3 3 0 0 0 2.83-4H12v-1z"
          fill="white"
        />
      </svg>
    ),
  },
];

// ─── COMPONENTS ──────────────────────────────────────────────────────────────
function GlowOrb({ className }) {
  return (
    <div
      className={`absolute rounded-full blur-3xl opacity-20 pointer-events-none ${className}`}
    />
  );
}

const NAV_ITEMS = [
  { label: "About", to: "/about" },
  { label: "Projects", href: "#projects" },
  { label: "CRM", to: "/crm" },
  { label: "ClaimGuard NEMT", to: "/services/nemt-solutions" },
  // { label: "Security Guard", to: "/services/security-guard-solutions" }, // hidden for now
  { label: "Contact", to: "/contact" },
];

const DROPDOWN_SERVICES = [
  { label: "Web Development", to: "/services/web-development" },
  { label: "Mobile Apps", to: "/services/mobile-apps" },
  { label: "Backend Engineering", to: "/services/backend-engineering" },
  { label: "Cloud Solutions", to: "/services/cloud-solutions" },
  { label: "UI/UX Design", to: "/services/uiux-design" },
  { label: "AI & Automation", to: "/services/ai-automation" },
  { label: "ClaimGuard NEMT", to: "/services/nemt-solutions" },
  // { label: "Security Guard Solutions", to: "/services/security-guard-solutions" }, // hidden for now
  { label: "AI Solutions", to: "/ai-services" },
  { label: "SEO Services Texas", to: "/seo-services" },
];

function ServicesDropdown({ onClick }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isActive =
    location.pathname.startsWith("/services") ||
    location.pathname === "/ai-services" ||
    location.pathname === "/seo-services";

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        className={`flex items-center gap-1 px-4 py-2 text-sm transition-colors duration-200 rounded-lg hover:bg-white/5 font-medium tracking-wide ${isActive ? "text-white" : "text-slate-400 hover:text-white"}`}
      >
        Services
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          className={`w-3 h-3 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute top-full left-0 pt-2 z-50 min-w-[220px]">
          <div className="rounded-2xl border border-white/10 bg-[#0a0d1a]/95 backdrop-blur-xl shadow-2xl shadow-black/50 p-2">
            <Link
              to="/services"
              onClick={onClick}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs text-violet-400 hover:text-white hover:bg-violet-500/10 transition-colors font-semibold uppercase tracking-wider mb-1"
            >
              View All Services →
            </Link>
            <div className="h-px bg-white/5 mb-1" />
            {DROPDOWN_SERVICES.map((svc) => (
              <Link
                key={svc.to}
                to={svc.to}
                onClick={onClick}
                className={`flex items-center px-3 py-2 rounded-lg text-sm transition-colors ${
                  location.pathname === svc.to
                    ? "text-white bg-white/5"
                    : "text-slate-400 hover:text-white hover:bg-white/5"
                }`}
              >
                {svc.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function NavBar({ scrolled, mobileOpen, setMobileOpen }) {
  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-[#050810]/90 backdrop-blur-xl border-b border-white/5 shadow-2xl shadow-black/30" : "bg-transparent"}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <div className="flex items-center gap-3">
            <img src={logo} alt="BerryByte Innovations" />
          </div>

          <nav className="hidden md:flex items-center gap-1">
            <ServicesDropdown />
            {NAV_ITEMS.map((item) =>
              item.to ? (
                <Link
                  key={item.label}
                  to={item.to}
                  className="nav-underline px-4 py-2 text-sm text-slate-400 hover:text-white transition-colors duration-200 rounded-lg hover:bg-white/5 font-medium tracking-wide"
                >
                  {item.label}
                </Link>
              ) : (
                <a
                  key={item.label}
                  href={item.href}
                  className="nav-underline px-4 py-2 text-sm text-slate-400 hover:text-white transition-colors duration-200 rounded-lg hover:bg-white/5 font-medium tracking-wide"
                >
                  {item.label}
                </a>
              ),
            )}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/contact"
              className="px-5 py-2.5 rounded-xl text-sm font-semibold bg-gradient-to-r from-violet-600 to-cyan-600 text-white hover:from-violet-500 hover:to-cyan-500 transition-all duration-200 shadow-lg shadow-violet-900/30 hover:shadow-violet-900/50 hover:-translate-y-0.5"
            >
              Get Started
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden text-slate-400 hover:text-white transition-colors p-1"
          >
            {mobileOpen ? <Icons.Close /> : <Icons.Menu />}
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${mobileOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"}`}
      >
        <div className="px-6 py-4 bg-[#050810]/95 backdrop-blur-xl border-t border-white/5 flex flex-col gap-2">
          {/* Services group */}
          <div>
            <Link
              to="/services"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-between px-4 py-3 text-slate-300 hover:text-white hover:bg-white/5 rounded-xl transition-all duration-200 font-medium"
            >
              Services
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3 h-3">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </Link>
            <div className="ml-4 mt-1 flex flex-col gap-1 border-l border-white/5 pl-4">
              {DROPDOWN_SERVICES.map((svc) => (
                <Link
                  key={svc.to}
                  to={svc.to}
                  onClick={() => setMobileOpen(false)}
                  className="py-1.5 text-sm text-slate-500 hover:text-white transition-colors"
                >
                  {svc.label}
                </Link>
              ))}
            </div>
          </div>
          {NAV_ITEMS.map((item) =>
            item.to ? (
              <Link
                key={item.label}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-slate-300 hover:text-white hover:bg-white/5 rounded-xl transition-all duration-200 font-medium"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-slate-300 hover:text-white hover:bg-white/5 rounded-xl transition-all duration-200 font-medium"
              >
                {item.label}
              </a>
            ),
          )}
          <Link
            to="/contact"
            onClick={() => setMobileOpen(false)}
            className="mt-2 px-4 py-3 rounded-xl text-center text-sm font-semibold bg-gradient-to-r from-violet-600 to-cyan-600 text-white"
          >
            Get Started
          </Link>
        </div>
      </div>
    </header>
  );
}

// Floating tech chips framing the home hero — decorative, ultra-wide only
function HomeHeroDecor() {
  return (
    <div aria-hidden="true" className="hidden 2xl:block absolute inset-0 pointer-events-none select-none">
      <IlloStyles />
      {/* code window — web */}
      <div className="illo-float absolute left-14 top-40 w-44 rounded-2xl border border-violet-500/20 bg-white/[0.03] backdrop-blur-sm p-3 opacity-80">
        <div className="flex gap-1.5 mb-2">
          <span className="w-2 h-2 rounded-full bg-rose-400/70" />
          <span className="w-2 h-2 rounded-full bg-amber-400/70" />
          <span className="w-2 h-2 rounded-full bg-emerald-400/70" />
        </div>
        <div className="h-1.5 w-4/5 rounded bg-violet-400/50 mb-1.5" />
        <div className="h-1.5 w-3/5 rounded bg-white/15 mb-1.5 ml-2" />
        <div className="h-1.5 w-2/3 rounded bg-cyan-400/40 ml-2" />
      </div>
      {/* deploy chip — cloud */}
      <div className="illo-float-rev absolute left-24 bottom-48 w-44 rounded-2xl border border-sky-500/20 bg-white/[0.03] backdrop-blur-sm p-3 opacity-80">
        <div className="flex items-center gap-2 mb-2">
          <svg viewBox="0 0 24 24" fill="none" stroke="#38bdf8" strokeWidth="1.5" className="w-4 h-4">
            <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
          </svg>
          <span className="text-[10px] text-slate-400 font-mono">deploying…</span>
        </div>
        <div className="h-1.5 rounded bg-white/10 overflow-hidden">
          <div className="illo-progress h-full w-full rounded bg-sky-400/70" />
        </div>
      </div>
      {/* notification chip — mobile */}
      <div className="illo-float-rev absolute right-14 top-44 w-48 rounded-2xl border border-cyan-500/20 bg-white/[0.03] backdrop-blur-sm p-3 opacity-80">
        <div className="flex items-center gap-2.5">
          <span className="relative w-8 h-8 rounded-xl bg-cyan-500/15 border border-cyan-500/30 flex items-center justify-center">
            <svg viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="1.5" className="w-4 h-4">
              <rect x="5" y="2" width="14" height="20" rx="2" />
              <path d="M12 18h.01" />
            </svg>
            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-rose-500 animate-ping" />
            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-rose-500" />
          </span>
          <div>
            <div className="h-1.5 w-20 rounded bg-white/20 mb-1.5" />
            <div className="h-1.5 w-14 rounded bg-white/10" />
          </div>
        </div>
      </div>
      {/* AI chip */}
      <div className="illo-float absolute right-24 bottom-52 w-44 rounded-2xl border border-amber-500/20 bg-white/[0.03] backdrop-blur-sm p-3 opacity-80">
        <div className="flex items-center gap-2 mb-2">
          <svg viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="1.5" className="w-4 h-4">
            <rect x="4" y="8" width="16" height="10" rx="2" />
            <path d="M8 8V6a4 4 0 0 1 8 0v2" />
          </svg>
          <span className="text-[10px] text-slate-400 font-mono">AI assistant</span>
        </div>
        <div className="flex gap-1.5 items-center">
          <span className="illo-dot w-1.5 h-1.5 rounded-full bg-slate-300 inline-block" />
          <span className="illo-dot w-1.5 h-1.5 rounded-full bg-slate-300 inline-block" style={{ animationDelay: "0.18s" }} />
          <span className="illo-dot w-1.5 h-1.5 rounded-full bg-slate-300 inline-block" style={{ animationDelay: "0.36s" }} />
          <span className="illo-type h-1.5 w-16 rounded bg-amber-400/40 inline-block ml-1" />
        </div>
      </div>
    </div>
  );
}

function HeroSection() {
  const [count, setCount] = useState(0);
  // Decorative orbs drift on a slow float loop + gentle scroll parallax
  const orbsRef = useParallax(0.1);
  useEffect(() => {
    const t = setInterval(() => setCount((c) => (c + 1) % 3), 3500);
    return () => clearInterval(t);
  }, []);

  const headlines = [
    "We Build Software",
    "We Ship Products",
    "We Scale Dreams",
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-[#050810]"
    >
      <div ref={orbsRef} className="absolute inset-0 pointer-events-none">
        <GlowOrb className="orb-float w-[800px] h-[800px] bg-violet-600 -top-40 -left-40" />
        <GlowOrb className="orb-float-slow w-[600px] h-[600px] bg-cyan-600 top-1/2 -right-32" />
        <GlowOrb className="orb-float w-[400px] h-[400px] bg-indigo-600 bottom-0 left-1/3" />
      </div>
      <HomeHeroDecor />
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-24">
        <div className="text-center max-w-5xl mx-auto">
          <div
            className="hero-in inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-violet-500/30 bg-violet-500/10 text-violet-300 text-sm font-medium mb-8 backdrop-blur-sm"
            style={{ animationDelay: "0ms" }}
          >
            <span className="w-2 h-2 rounded-full bg-violet-400 animate-pulse" />
            Now accepting new clients · US & Canada
          </div>

          {/* Animated headline — decorative, screen-reader hidden */}
          <div
            className="hero-in h-24 sm:h-20 lg:h-24 flex items-center justify-center mb-4 overflow-hidden"
            style={{ animationDelay: "120ms" }}
            aria-hidden="true"
          >
            {headlines.map((h, i) => (
              <div
                key={i}
                className={`absolute text-4xl sm:text-5xl lg:text-7xl font-black tracking-tight text-white transition-all duration-700 ${i === count ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
              >
                {h}
              </div>
            ))}
          </div>

          {/* Single H1 — SEO-meaningful, screen-reader primary */}
          <h1
            className="hero-in text-4xl sm:text-5xl lg:text-7xl font-black tracking-tight mb-6"
            style={{ animationDelay: "220ms" }}
          >
            <span className="sr-only">
              Custom Software Development Agency —{" "}
            </span>
            <span className="bg-gradient-to-r from-violet-400 via-cyan-400 to-emerald-400 bg-clip-text text-transparent">
              That Actually Lasts.
            </span>
          </h1>

          <p
            className="hero-in text-lg sm:text-xl text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed font-light"
            style={{ animationDelay: "320ms" }}
          >
            BerryByte Innovations is a product-minded software studio. We
            architect, build, and scale digital products for startups and
            enterprises across the US & Canada — from zero to millions.
          </p>

          <div
            className="hero-in flex flex-col sm:flex-row gap-4 justify-center items-center"
            style={{ animationDelay: "420ms" }}
          >
            <Link
              to="/contact"
              className="group grad-animate w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 rounded-2xl bg-gradient-to-r from-violet-600 via-indigo-600 to-cyan-600 text-white font-semibold text-base shadow-2xl shadow-violet-900/40 hover:shadow-violet-900/60 hover:-translate-y-1 transition-all duration-300"
            >
              Get Started
              <span className="group-hover:translate-x-1 transition-transform duration-200">
                <Icons.ArrowRight />
              </span>
            </Link>
            <a
              href="#projects"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 rounded-2xl border border-white/10 text-white font-semibold text-base bg-white/5 hover:bg-white/10 hover:-translate-y-1 transition-all duration-300 backdrop-blur-sm"
            >
              View Our Work
            </a>
          </div>

          <div
            className="hero-in mt-20 grid grid-cols-2 sm:grid-cols-4 gap-8 pt-12 border-t border-white/5"
            style={{ animationDelay: "540ms" }}
          >
            {[
              { value: "120+", label: "Projects Shipped" },
              { value: "98%", label: "Client Retention" },
              { value: "6yrs", label: "In Business" },
              { value: "40+", label: "Engineers" },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div className="text-3xl font-black text-white mb-1">
                  <CountUp value={s.value} />
                </div>
                <div className="text-sm text-slate-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#050810] to-transparent" />
    </section>
  );
}

function ReviewPlatformsSection() {
  return (
    <section className="relative py-16 bg-[#070b14] overflow-hidden border-y border-white/5">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal variant="fade">
          <div className="text-center mb-10">
            <span className="text-slate-500 text-sm font-medium tracking-widest uppercase">
              Recognized by industry leaders
            </span>
          </div>
        </Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEW_PLATFORMS.map((platform, i) => {
            return (
              <Reveal key={platform.name} variant="scale" delay={i * 80}>
              <div
                className="flex flex-col items-center gap-3 p-5 rounded-2xl border transition-all duration-300 hover:-translate-y-1"
                style={{
                  borderColor: platform.borderColor,
                  background: platform.bgColor,
                }}
              >
                <div className="flex items-center justify-center h-8">
                  <span
                    className="text-lg font-black"
                    style={{ color: platform.color }}
                  >
                    {platform.name}
                  </span>
                </div>
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <svg
                      key={s}
                      viewBox="0 0 24 24"
                      fill={platform.color}
                      className="w-4 h-4"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                  ))}
                </div>
                <div className="text-center">
                  <div className="text-white font-bold text-xl">
                    {platform.rating}
                  </div>
                  <div className="text-slate-500 text-xs">
                    {platform.reviews}
                  </div>
                </div>
              </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function ServicesSection() {
  const SERVICE_ROUTES = {
    Web: "/services/web-development",
    Mobile: "/services/mobile-apps",
    Backend: "/services/backend-engineering",
    Cloud: "/services/cloud-solutions",
    Design: "/services/uiux-design",
    AI: "/services/ai-automation",
    Code: "/services",
    Claim: "/services/nemt-solutions",
  };

  return (
    <section
      id="services"
      className="relative py-28 bg-[#070b14] overflow-hidden"
    >
      <GlowOrb className="w-[600px] h-[600px] bg-cyan-700 -top-32 -right-48" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal variant="blur">
          <div className="text-center mb-16">
            <span className="text-cyan-400 font-semibold text-sm tracking-widest uppercase">
              What We Do
            </span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-black text-white">
              Full-stack expertise,
              <br />
              end-to-end delivery.
            </h2>
            <p className="mt-4 text-slate-400 max-w-xl mx-auto">
              From napkin sketch to global scale — we have every discipline under
              one roof.
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((svc, i) => {
            const Icon = Icons[svc.icon];
            const route = SERVICE_ROUTES[svc.icon];
            return (
              <Reveal key={svc.title} delay={(i % 3) * 90} className="h-full">
              <Link
                to={route}
                className={`group relative flex flex-col h-full rounded-2xl border ${svc.border} bg-gradient-to-br ${svc.color} p-6 hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 overflow-hidden`}
              >
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"
                  style={{
                    background:
                      "radial-gradient(circle at 50% 0%, rgba(255,255,255,0.04), transparent 60%)",
                  }}
                />
                <div
                  className={`icon-pop self-start inline-flex p-3 rounded-xl bg-white/5 border border-white/10 ${svc.accent} mb-5`}
                >
                  <Icon />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">
                  {svc.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {svc.desc}
                </p>
                <div
                  className={`mt-4 inline-flex items-center gap-1.5 text-xs font-semibold ${svc.accent} opacity-60 group-hover:opacity-100 transition-opacity duration-200`}
                >
                  Learn More
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="w-3 h-3 group-hover:translate-x-0.5 transition-transform duration-200"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </div>
              </Link>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-white/10 text-slate-300 hover:text-white hover:bg-white/5 text-sm font-medium transition-all duration-200"
          >
            View all services
            <Icons.ArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
}

function TechStackSection() {
  return (
    <section id="stack" className="relative py-28 bg-[#050810] overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal variant="up">
          <div className="text-center mb-16">
            <span className="text-emerald-400 font-semibold text-sm tracking-widest uppercase">
              Our Tech Stack
            </span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-black text-white">
              Battle-tested technologies,
              <br />
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                production-grade results.
              </span>
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-4">
          {TECH_STACK.map((tech, i) => (
            <Reveal key={tech.name} variant="scale" delay={(i % 6) * 60}>
              <div className="group flex flex-col items-center gap-3 p-5 rounded-2xl border border-white/5 bg-white/[0.02] hover:bg-white/[0.06] hover:border-white/10 hover:-translate-y-1 transition-all duration-300 cursor-default">
                <span className="icon-pop inline-flex">
                  <tech.IconComp />
                </span>
                <span className="text-slate-400 group-hover:text-white text-xs font-medium transition-colors">
                  {tech.name}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Reveal variant="fade" delay={200}>
            <p className="text-slate-500 text-sm">
              And many more. We pick the right tool, not the trendy one.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function ProjectsSection() {
  return (
    <section
      id="projects"
      className="relative py-28 bg-[#070b14] overflow-hidden"
    >
      <GlowOrb className="w-[500px] h-[500px] bg-violet-700 bottom-0 left-1/4" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal variant="blur">
          <div className="text-center mb-16">
            <span className="text-rose-400 font-semibold text-sm tracking-widest uppercase">
              Portfolio
            </span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-black text-white">
              Products we're proud of.
            </h2>
            <p className="mt-4 text-slate-400 max-w-xl mx-auto">
              Real projects, real scale, real results. Here's a sample of what
              we've built.
            </p>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-6">
          {PROJECTS.map((proj, i) => (
            <Reveal
              key={proj.title}
              variant={i % 2 === 0 ? "right" : "left"}
              delay={i * 100}
              className="h-full"
            >
            <div
              className="group relative h-full rounded-3xl border border-white/5 bg-white/[0.02] overflow-hidden hover:-translate-y-2 hover:shadow-2xl hover:shadow-black/40 transition-all duration-400 flex flex-col"
            >
              <div
                className={`h-1.5 w-full bg-gradient-to-r ${proj.gradient}`}
              />
              <div className="relative w-full h-48 overflow-hidden bg-gradient-to-br from-white/5 to-white/[0.02]">
                <img
                  src={proj.image}
                  alt={proj.title}
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div
                  className={`absolute top-3 right-3 w-10 h-10 rounded-2xl bg-gradient-to-br ${proj.gradient} flex items-center justify-center opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 shadow-lg`}
                >
                  <span className="text-white font-black text-sm">
                    {proj.title[0]}
                  </span>
                </div>
              </div>
              <div className="p-8 flex-grow flex flex-col">
                <div className="mb-4">
                  <span className="text-xs font-medium text-slate-500 uppercase tracking-wider">
                    {proj.category}
                  </span>
                  <h3 className="mt-1 text-2xl font-black text-white">
                    {proj.title}
                  </h3>
                </div>
                <p className="text-slate-400 text-sm leading-relaxed mb-6 flex-grow">
                  {proj.desc}
                </p>
                <div className="grid grid-cols-3 gap-4 mb-6 p-4 rounded-xl bg-white/[0.03] border border-white/5">
                  {proj.stats.map((s) => (
                    <div key={s.label} className="text-center">
                      <div className="text-lg font-bold text-white">
                        {s.value}
                      </div>
                      <div className="text-xs text-slate-500">{s.label}</div>
                    </div>
                  ))}
                </div>
                <div className="flex flex-wrap gap-2">
                  {proj.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-lg bg-white/5 border border-white/8 text-xs text-slate-400 font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

function VideoTestimonialsSection() {
  const [playing, setPlaying] = useState(null);

  return (
    <section
      id="testimonials"
      className="relative py-28 bg-[#070b14] overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal variant="up">
          <div className="text-center mb-16">
            <span className="text-amber-400 font-semibold text-sm tracking-widest uppercase">
              Client Stories
            </span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-black text-white">
              Don't take our word for it.
            </h2>
            <p className="mt-4 text-slate-400 max-w-xl mx-auto">
              Hear directly from the founders and CTOs who shipped with us.
            </p>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} variant="up" delay={i * 120}>
            <div
              className="group relative rounded-3xl border border-white/8 bg-white/[0.02] overflow-hidden hover:-translate-y-2 hover:shadow-2xl hover:shadow-black/50 transition-all duration-400"
            >
              <div className="relative w-full aspect-video bg-[#0a0d18] overflow-hidden">
                {playing === i ? (
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${t.videoId}?autoplay=1&rel=0&modestbranding=1`}
                    title={`${t.name} testimonial`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <>
                    <img
                      src={`https://img.youtube.com/vi/${t.videoId}/maxresdefault.jpg`}
                      alt={`${t.name} testimonial`}
                      className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-75 group-hover:scale-105 transition-all duration-500"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#070b14] via-transparent to-transparent" />
                    <button
                      onClick={() => setPlaying(i)}
                      className="absolute inset-0 flex items-center justify-center group/btn"
                    >
                      <div className="relative w-16 h-16 rounded-full bg-white/10 border-2 border-white/30 backdrop-blur-sm flex items-center justify-center group-hover/btn:bg-white/20 group-hover/btn:scale-110 group-hover/btn:border-white/50 transition-all duration-300">
                        <svg
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-6 h-6 text-white ml-1"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </button>
                  </>
                )}
              </div>

              <div className="p-6">
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, s) => (
                    <Icons.Star key={s} />
                  ))}
                </div>
                <blockquote className="text-slate-300 text-sm leading-relaxed mb-5 relative">
                  <span className="absolute -top-1 -left-1 text-3xl text-violet-500/40 font-serif leading-none">
                    "
                  </span>
                  <span className="relative pl-3">{t.feedback}</span>
                </blockquote>
                <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                  <div
                    className={`w-10 h-10 rounded-xl bg-gradient-to-br ${t.avatarColor} flex items-center justify-center text-white text-xs font-black flex-shrink-0`}
                  >
                    {t.avatar}
                  </div>
                  <div>
                    <div className="text-white font-semibold text-sm">
                      {t.name}
                    </div>
                    <div className="text-slate-500 text-xs">{t.role}</div>
                  </div>
                  <div className="ml-auto px-2.5 py-1 rounded-lg bg-white/5 border border-white/8">
                    <span className="text-slate-400 text-xs font-medium">
                      {t.company}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            </Reveal>
          ))}
        </div>

        {/* Trust badges */}
        <div className="mt-14 flex flex-wrap justify-center gap-6">
          {[
            { Icon: Icons.Shield, label: "NDA Protected" },
            { Icon: Icons.Star, label: "4.9/5 Average Rating" },
            { Icon: Icons.Trophy, label: "Top Rated on Clutch" },
            { Icon: Icons.Verified, label: "ISO 27001 Certified" },
          ].map((badge, i) => (
            <Reveal key={badge.label} variant="scale" delay={i * 70}>
              <div className="flex items-center gap-2 px-4 py-2 rounded-xl border border-white/8 bg-white/[0.02] text-slate-400 text-sm">
                <span className="text-violet-400">
                  <badge.Icon />
                </span>
                <span className="font-medium">{badge.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch("https://api.berrybyteinn.com/api/contact-us", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          full_name: form.name,
          email: form.email,
          phone_number: form.phone,
          subject: form.subject,
          message: form.message,
          platform: "berry",
        }),
      });
      if (!res.ok) throw new Error("Request failed");
      setSent(true);
    } catch {
      setError("Something went wrong. Please try again or email us directly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contact"
      className="relative py-28 bg-[#050810] overflow-hidden"
    >
      <GlowOrb className="w-[700px] h-[700px] bg-violet-700 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <Reveal variant="right">
          <div>
            <span className="text-violet-400 font-semibold text-sm tracking-widest uppercase">
              Get In Touch
            </span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-black text-white leading-tight">
              Ready to build
              <br />
              <span className="bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">
                something great?
              </span>
            </h2>
            <p className="mt-6 text-slate-400 text-lg leading-relaxed">
              We'd love to hear about your project. Drop us a message and our
              team will get back to you within one business day.
            </p>

            <div className="mt-10 flex flex-col gap-5">
              {[
                {
                  Icon: Icons.Mail,
                  label: "Email Us",
                  value: "sales@berrybyteinn.com",
                  href: "mailto:sales@berrybyteinn.com",
                },
                {
                  Icon: Icons.Phone,
                  label: "Call Us",
                  value: "+1 201-846-9830",
                  href: "tel:+12018469830",
                },
                {
                  Icon: Icons.Location,
                  label: "Locations",
                  values: ["Texas, United States", "Karachi, Pakistan"],
                },
              ].map(({ Icon, label, value, href, values }) => (
                <div key={label} className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-xl bg-violet-500/10 border border-violet-500/20 flex items-center justify-center text-violet-400 flex-shrink-0">
                    <Icon />
                  </div>
                  <div>
                    <div className="text-xs text-slate-500 font-medium">
                      {label}
                    </div>
                    {values ? (
                      <div className="flex flex-col gap-0.5">
                        {values.map((v) => (
                          <div
                            key={v}
                            className="text-slate-200 text-sm font-medium"
                          >
                            {v}
                          </div>
                        ))}
                      </div>
                    ) : href ? (
                      <a
                        href={href}
                        className="text-slate-200 text-sm font-medium hover:text-white transition-colors"
                      >
                        {value}
                      </a>
                    ) : (
                      <div className="text-slate-200 text-sm font-medium">
                        {value}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 p-5 rounded-2xl border border-emerald-500/20 bg-emerald-500/5">
              <div className="flex items-center gap-2 mb-1">
                <span className="w-2.5 h-2.5 rounded-full bg-emerald-400 animate-pulse" />
                <span className="text-emerald-400 text-sm font-semibold">
                  Currently accepting new projects
                </span>
              </div>
              <p className="text-slate-400 text-sm">
                Typical response time: 4–8 business hours
              </p>
            </div>
          </div>
          </Reveal>

          <Reveal variant="left" delay={120}>
          <div className="rounded-3xl border border-white/8 bg-white/[0.02] p-8 backdrop-blur-sm">
            {sent ? (
              <div className="h-full flex flex-col items-center justify-center text-center py-12">
                <div className="w-16 h-16 rounded-full bg-emerald-500/20 border border-emerald-500/30 flex items-center justify-center mb-4">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="w-8 h-8 text-emerald-400"
                  >
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  Message Sent!
                </h3>
                <p className="text-slate-400">
                  Thanks for reaching out. We'll be in touch shortly.
                </p>
                <button
                  onClick={() => {
                    setSent(false);
                    setForm({
                      name: "",
                      email: "",
                      phone: "",
                      subject: "",
                      message: "",
                    });
                    setError("");
                  }}
                  className="mt-6 px-6 py-2.5 rounded-xl border border-white/10 text-slate-300 hover:text-white hover:bg-white/5 text-sm transition-all"
                >
                  Send another
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                <div className="grid sm:grid-cols-2 gap-5">
                  <div>
                    <label className="text-xs font-medium text-slate-400 block mb-2">
                      Full Name
                    </label>
                    <input
                      required
                      value={form.name}
                      onChange={(e) =>
                        setForm({ ...form, name: e.target.value })
                      }
                      placeholder="Jane Doe"
                      className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/8 text-white placeholder-slate-600 text-sm focus:outline-none focus:border-violet-500/50 focus:bg-white/8 transition-all duration-200"
                    />
                  </div>
                  <div>
                    <label className="text-xs font-medium text-slate-400 block mb-2">
                      Email Address
                    </label>
                    <input
                      required
                      type="email"
                      value={form.email}
                      onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                      }
                      placeholder="jane@company.com"
                      className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/8 text-white placeholder-slate-600 text-sm focus:outline-none focus:border-violet-500/50 focus:bg-white/8 transition-all duration-200"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-xs font-medium text-slate-400 block mb-2">
                    Phone Number
                  </label>
                  <input
                    required
                    type="tel"
                    value={form.phone}
                    onChange={(e) =>
                      setForm({ ...form, phone: e.target.value })
                    }
                    placeholder="+1 201-846-9830"
                    className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/8 text-white placeholder-slate-600 text-sm focus:outline-none focus:border-violet-500/50 focus:bg-white/8 transition-all duration-200"
                  />
                </div>
                <div>
                  <label className="text-xs font-medium text-slate-400 block mb-2">
                    Subject
                  </label>
                  <input
                    value={form.subject}
                    onChange={(e) =>
                      setForm({ ...form, subject: e.target.value })
                    }
                    placeholder="Project inquiry, partnership, etc."
                    className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/8 text-white placeholder-slate-600 text-sm focus:outline-none focus:border-violet-500/50 focus:bg-white/8 transition-all duration-200"
                  />
                </div>
                <div>
                  <label className="text-xs font-medium text-slate-400 block mb-2">
                    Message
                  </label>
                  <textarea
                    required
                    rows={5}
                    value={form.message}
                    onChange={(e) =>
                      setForm({ ...form, message: e.target.value })
                    }
                    placeholder="Tell us about your project, timeline, and budget..."
                    className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/8 text-white placeholder-slate-600 text-sm focus:outline-none focus:border-violet-500/50 focus:bg-white/8 transition-all duration-200 resize-none"
                  />
                </div>
                {error && (
                  <p className="text-rose-400 text-sm text-center">{error}</p>
                )}
                <button
                  type="submit"
                  disabled={loading}
                  className="grad-animate w-full py-4 rounded-xl bg-gradient-to-r from-violet-600 via-indigo-600 to-cyan-600 text-white font-semibold text-sm hover:-translate-y-0.5 shadow-lg shadow-violet-900/30 hover:shadow-violet-900/50 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0"
                >
                  {loading ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg
                        className="animate-spin w-4 h-4"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                      </svg>
                      Sending...
                    </span>
                  ) : (
                    "Send Message"
                  )}
                </button>
              </form>
            )}
          </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function PartnersMarquee() {
  const PARTNERS = [
    { name: "Google", color: "#4285F4" },
    { name: "Amazon", color: "#FF9900" },
    { name: "Stripe", color: "#635BFF" },
    { name: "Microsoft", color: "#00A4EF" },
    { name: "Vercel", color: "#ffffff" },
    { name: "Figma", color: "#F24E1E" },
    { name: "Shopify", color: "#96BF48" },
    { name: "Twilio", color: "#F22F46" },
    { name: "Cloudflare", color: "#F48120" },
    { name: "Notion", color: "#ffffff" },
  ];

  return (
    <section className="relative py-20 bg-[#050810] overflow-hidden border-y border-white/5">
      <Reveal variant="fade">
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 mb-10 text-center">
          <span className="text-slate-500 text-sm font-medium tracking-widest uppercase">
            Trusted by teams at the world's best companies
          </span>
        </div>
      </Reveal>

      <div
        className="absolute left-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{
          background: "linear-gradient(to right, #050810 0%, transparent 100%)",
        }}
      />
      <div
        className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{
          background: "linear-gradient(to left, #050810 0%, transparent 100%)",
        }}
      />

      <div className="flex overflow-hidden group">
        <div className="flex gap-10 animate-marquee group-hover:[animation-play-state:paused] whitespace-nowrap">
          {[...PARTNERS, ...PARTNERS].map((p, i) => (
            <div
              key={i}
              className="inline-flex items-center gap-3 px-7 py-4 rounded-2xl border border-white/5 bg-white/[0.025] hover:bg-white/[0.05] hover:border-white/10 transition-all duration-300 flex-shrink-0 cursor-default opacity-50 hover:opacity-100"
            >
              <span
                className="w-7 h-7 rounded-lg flex items-center justify-center text-xs font-black"
                style={{ color: p.color, background: `${p.color}18` }}
              >
                {p.name[0]}
              </span>
              <span className="text-slate-300 font-semibold text-sm tracking-wide">
                {p.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 28s linear infinite;
        }
      `}</style>
    </section>
  );
}

function Footer() {
  return (
    <footer className="bg-[#030508] border-t border-white/5 py-16">
      <Reveal variant="fade">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <img src={logo} alt="BerryByte Innovations" />
            </div>
            <p className="text-slate-500 text-sm leading-relaxed mt-3">
              Engineering the future, one commit at a time. Trusted by startups
              and enterprises across the US & Canada.
            </p>
            <div className="flex gap-3 mt-5">
              {[
                {
                  Icon: Icons.Twitter,
                  href: "https://x.com/berryByte4",
                  label: "Twitter",
                },
                {
                  Icon: Icons.Github,
                  href: "https://github.com/berrybyte",
                  label: "GitHub",
                },
                {
                  Icon: Icons.LinkedIn,
                  href: "https://www.linkedin.com/company/berrybyteinnovations/",
                  label: "LinkedIn",
                },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-xl border border-white/8 bg-white/[0.03] flex items-center justify-center text-slate-500 hover:text-white hover:border-white/15 hover:bg-white/[0.06] hover:-translate-y-1 hover:scale-105 transition-all duration-200"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Services</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: "Web Development", to: "/services/web-development" },
                { label: "Mobile Apps", to: "/services/mobile-apps" },
                {
                  label: "Backend Engineering",
                  to: "/services/backend-engineering",
                },
                { label: "Cloud Solutions", to: "/services/cloud-solutions" },
                { label: "UI/UX Design", to: "/services/uiux-design" },
                { label: "AI & Automation", to: "/services/ai-automation" },
                { label: "ClaimGuard NEMT", to: "/services/nemt-solutions" },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-slate-500 hover:text-slate-300 text-sm transition-colors duration-200"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Company</h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: "About Us", to: "/about" },
                { label: "All Services", to: "/services" },
                { label: "CRM Platform", to: "/crm" },
                { label: "Projects", href: "#projects" },
                { label: "Contact", to: "/contact" },
              ].map(({ label, to, href }) => (
                <li key={label}>
                  {to ? (
                    <Link
                      to={to}
                      className="text-slate-500 hover:text-slate-300 text-sm transition-colors duration-200"
                    >
                      {label}
                    </Link>
                  ) : (
                    <a
                      href={href}
                      className="text-slate-500 hover:text-slate-300 text-sm transition-colors duration-200"
                    >
                      {label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contact</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a
                  href="mailto:sales@berrybyteinn.com"
                  className="flex items-center gap-2 text-slate-500 hover:text-slate-300 text-sm transition-colors"
                >
                  <Icons.Mail />
                  sales@berrybyteinn.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+12018469830"
                  className="flex items-center gap-2 text-slate-500 hover:text-slate-300 text-sm transition-colors"
                >
                  <Icons.Phone />
                  +1 201-846-9830
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-500 text-sm">
                <span className="mt-0.5 flex-shrink-0">
                  <Icons.Location />
                </span>
                <div className="flex flex-col gap-0.5">
                  <span>Texas, United States</span>
                  <span>Karachi, Pakistan</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-600 text-sm">
            &copy; {new Date().getFullYear()} BerryByte Innovations. All rights
            reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy-policy"
              className="text-slate-600 hover:text-slate-400 text-xs transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-slate-600 hover:text-slate-400 text-xs transition-colors"
            >
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
      </Reveal>
    </footer>
  );
}

// ─── HOME PAGE ────────────────────────────────────────────────────────────────
function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useSEO({
    title: "Custom Software Dev Agency US & Canada | BerryByte",
    description:
      "Award-winning custom software development agency for US & Canadian startups and enterprises. Expert in web apps, mobile, AI automation & cloud solutions.",
    keywords:
      "custom software development agency, software development company for startups, React development agency, mobile app development, AI automation services, cloud solutions, web application development US Canada",
    canonical: "https://www.berrybyteinn.com/",
  });

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="font-sans antialiased text-white"
      style={{ fontFamily: "'DM Sans', 'Inter', system-ui, sans-serif" }}
    >
      <style>{`
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #050810; }
        ::-webkit-scrollbar-thumb { background: #2d2f45; border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: #4c4e6a; }
      `}</style>
      <AnimStyles />
      <NavBar
        scrolled={scrolled}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      <main>
        <HeroSection />
        <ReviewPlatformsSection />
        <PartnersMarquee />
        <ServicesSection />
        <TechStackSection />
        <ProjectsSection />
        <VideoTestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

// ─── APP ─────────────────────────────────────────────────────────────────────
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/crm" element={<CRMPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/services/web-development" element={<WebDevDetail />} />
        <Route path="/services/mobile-apps" element={<MobileAppsDetail />} />
        <Route
          path="/services/backend-engineering"
          element={<BackendDetail />}
        />
        <Route path="/services/cloud-solutions" element={<CloudDetail />} />
        <Route path="/services/uiux-design" element={<UIUXDetail />} />
        <Route
          path="/services/ai-automation"
          element={<AIAutomationDetail />}
        />
        <Route path="/services/nemt-solutions" element={<NEMTDetail />} />
        <Route
          path="/services/security-guard-solutions"
          element={<SecurityGuardDetail />}
        />
        <Route path="/seo-services" element={<SEOServicesPage />} />
        <Route path="/ai-services" element={<AIServicesPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
